import { Dispatch, FC, SetStateAction } from "react";
import { InternalButtonLink } from "../../InternalButtonLink";
import * as Styled from './PdfControls.styled';

type NumberState = [number, Dispatch<SetStateAction<number>>];

type PdfControlsProps = {
    scaleState: NumberState,
    min?: number,
    max?: number,
}

export const PdfControls: FC<PdfControlsProps> = (props) => {

    const { scaleState, min = 0.5, max = 2 } = props;
    const [scale, setScale] = scaleState;

    const scaleUp = (newScale: number) => {
        setScale(Math.min(max, newScale));
    }

    const scaleDown = (newScale: number) => {
        setScale(Math.max(min, newScale));
    }

    return (
        <Styled.Buttons direction={"row"}>
            <InternalButtonLink onClick={() => scaleUp(scale + 0.2)}>+</InternalButtonLink>
            <InternalButtonLink onClick={() => scaleDown(scale - 0.2)}>-</InternalButtonLink>
        </Styled.Buttons>

    )
}